import SharingTableContainer from './SharingTableContainer';

export default SharingTableContainer;
